"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as m } from "../../theme-variant-context.js";
import { vars as i } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: c, size: e = 24 } = _param, l = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const h = m(), r = c !== null && c !== void 0 ? c : h ? i.colors.inverse : i.colors.neutralHigh, { skinName: t } = n();
    return t.match(/^o2-new/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: /* @__PURE__ */ o("path", {
            fill: r,
            d: "m12.007 2-8.38 4.848 3.833 2.14 8.184-4.886zm-3.43 7.613 8.16-4.876 3.65 2.111-8.38 4.684zm2.872 2.869-8.39-4.684v9.349L11.45 22zM12.566 22v-9.518l8.389-4.684v9.349z"
        })
    })) : t.match(/^o2/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: /* @__PURE__ */ o("path", {
            fill: r,
            d: "m12.007 2-8.38 4.848 3.833 2.14 8.183-4.886zm-3.43 7.613 8.16-4.876 3.65 2.111-8.38 4.684zm2.872 2.869-8.39-4.684v9.349L11.45 22zM12.566 22v-9.518l8.389-4.684v9.349z"
        })
    })) : /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: /* @__PURE__ */ o("path", {
            fill: r,
            d: "M21.8 8.211a.5.5 0 0 1 .01.23c.017.09.031.179.034.28v11.448c0 .924-.818 1.678-1.826 1.678H3.984c-1.008 0-1.826-.754-1.826-1.678V8.72c0-.163.03-.317.078-.465q.002-.01.002-.02l.001-.02 1.333-4.739c.048-.734.77-1.32 1.653-1.32h13.549c.88 0 1.6.583 1.652 1.317zm-2.822-4.653c0-.098-.092-.173-.207-.176h-4.664l.462 3.655h5.398l-.966-3.333a.4.4 0 0 1-.023-.146m-13.96 0a.5.5 0 0 1-.02.143l-.944 3.34h5.042l.387-3.656h-4.26c-.113 0-.205.078-.205.173m14.994 17.054c.202 0 .378-.21.378-.449V8.715c0-.238-.176-.448-.378-.448h-5.361l.002 2.462c0 .34-.325.614-.725.614h-4.18c-.4 0-.725-.275-.725-.614V8.267H3.978c-.201 0-.375.21-.375.448v11.448c0 .238.174.448.375.448z"
        })
    }));
}, p = s;
export { p as default };
